angular.module('cerberus.cpc')
    .controller('initiateInventoryWarehouseAuditModalCtrl', function(_, $scope, $uibModalInstance, inventoryService){
        var vm = this;
        vm.emptyValue = '';
        vm.rollpositions_textarea = '';
        vm.rollpositions_textarea_roundTwo = '';
        vm.rowWarehouseSelected = '';
        vm.rowWarehouseList = [
            {value: '1', display: '(1) Roll room warehouse'},
            {value: '2', display: '(2) Production racks'},
            {value: '3', display: '(3) Other'}
        ];
        vm.auditCountId = '';
        vm.auditCountIdList = [
            {value: '1', display: 'Count ID 1'},
            {value: '2', display: 'Count ID 2'},
            {value: '3', display: 'Count ID 3'},
            {value: '4', display: 'Count ID 4'},
            {value: '5', display: 'Count ID 5'},
            {value: '6', display: 'Count ID 6'},
            {value: '7', display: 'Count ID 7'},
            {value: '8', display: 'Count ID 8'},
            {value: '9', display: 'Count ID 9'}
        ];
        vm.AuditHelper =  "..:: Useful information about how to interpret data ::..\n" +
                          "-- =*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=\n" +
                          "-- SCAN METHOD: [[ 'X number' is the AuditCount Number ]]   \n" +
                          "-- CASE #1: Roll Weight == '0', and AuditCount == X number. \n" +
                          "-- CASE #2: Roll Weight  > '0', and AuditCount <> X number. \n" +
                          "-- =*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*="; 

        vm.importingDataInProgress = false;
        vm.importingDataShowError = false;
        vm.isUnchanged = isUnchanged;
        vm.submit = submit;
        vm.cancel = cancel;

        // -- add here necessary fuctions needed to be processed within controller, when done, remove this... //

        // Check if text is empty
        function isUnchanged() {
            return angular.equals(vm.rollpositions_textarea, vm.emptyValue);
        }

        // Submit button execution
        function submit() {
            // Basic validation test, nothing special
            if (vm.rollpositions_textarea == 'test') {
                return;
            }
            // Manage progress monitoring
            vm.importingDataInProgress = true;
            vm.importingDataShowError = false;
            // Initiate function here
            var action = 'warehouse_audit'; // specify here exact action to be executed
            // join both text areas and send it as is. (use semicolon to split them).
            var dataCombined = vm.rollpositions_textarea + ';' + vm.rollpositions_textarea_roundTwo;
            var data = {
                'values': dataCombined,
                'auditcount': vm.auditCountId,
                'warehouse': vm.rowWarehouseSelected
            };
            inventoryService.updateRollPositions(action, data).then(function (result) {
                vm.importingDataInProgress = false;
                //console.log(result);
                if (result.errMsg) {
                    vm.importingDataShowError = true;
                 //   vm.importError = result.errMsg;
                 //console.log('aaaaaaaaaaabbbbbb');
                }
                //else if (result.instanceId) {
                //    $uibModalInstance.close(result.instanceId);
                //}
                else {
                    $uibModalInstance.close(result.instanceId);
                }
            }, function () {
                vm.importingDataInProgress = false;
                vm.importingDataShowError = false;
            });
        }

        // Cancel button execution
        function cancel() {
            $uibModalInstance.dismiss();
        }

        // Removes Kendo widgets
        //$scope.$on('$destroy', function() {
        //    _.result(vm, 'updateInventoryUpload.destroy');
        //});

        // Prevents navigation while modal is open
        var allowNavigation = $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });

        $scope.$on('modal.closing', function () {
            allowNavigation();
        });
    })
;